import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";





const save = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/commercial-component-action", data, headerConfig);
        return response.data;
  };


const list = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/commercialcomponent", {}, headerConfig);
        return response;
};


const programmeCommercialByOptions = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/commercial-component-programme", data, headerConfig);
        return response;
  };


  const programmeCommercialByOptionsHP = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/commercial-component-hp", data, headerConfig);
        return response;
  };

  const generateMonthlyFees = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/generate-monthly-fees-details", data, headerConfig);
        return response;
  };
  const monthlyFeesdetailComponent = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/monthly-fees-details-component", data, headerConfig);
        return response;
  };
  const monthlyFessUpdate = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/monthly-fees-update", data, headerConfig);
        return response;
  };



const ProgrammeCommercialService = {
    save,
    list,
    programmeCommercialByOptions,
    programmeCommercialByOptionsHP,
    generateMonthlyFees,
    monthlyFeesdetailComponent,
    monthlyFessUpdate
    
};

export default ProgrammeCommercialService;